var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"30px"}},[_c('b-input',{staticStyle:{"border":"none"},attrs:{"type":"color","size":"sm"},on:{"change":_vm.changePrimaryColor},model:{value:(_vm.primaryColor),callback:function ($$v) {_vm.primaryColor=$$v},expression:"primaryColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }